<template>
  <div class="container-fluid">
    <div class="card mb-3">
      <div class="card-body">
        <filters-form v-show="!displayResults" :selectedSortingProp="filters.selectedSorting" :pageSizeProp="filters.pageSize"
          @filtersConfirmed="setFilters" />
        <ticket-result-list v-if="displayResults & filters?.selectedReportType?.key == 1"
          :resultsList="resultsList" :selectedSorting="filters.selectedSorting" :pageSize="filters.pageSize"
          :pageIndex="filters.pageIndex" @paginationUpdate="updatePagination" @sortingUpdate="updateSorting" @showFilters="showFilters" />
        <user-result-list v-if="displayResults & filters?.selectedReportType?.key == 5"
          :resultsList="resultsList" :selectedSorting="filters.selectedSorting" :pageSize="filters.pageSize"
          :pageIndex="filters.pageIndex" @paginationUpdate="updatePagination" @sortingUpdate="updateSorting" @showFilters="showFilters" />
        <customer-result-list v-if="displayResults & filters?.selectedReportType?.key == 9"
          :resultsList="resultsList" :selectedSorting="filters.selectedSorting" :pageSize="filters.pageSize"
          :pageIndex="filters.pageIndex" @paginationUpdate="updatePagination" @sortingUpdate="updateSorting" @showFilters="showFilters" />
      </div>
    </div>
  </div>
</template>

<script>
import ReportService from '../../../services/ReportService';
import CustomerResultList from './CustomerResultList.vue';
import FiltersForm from './FiltersForm.vue';
import TicketResultList from './TicketResultList.vue';
import UserResultList from './UserResultList.vue';

export default {
  components: { FiltersForm, TicketResultList, UserResultList, CustomerResultList },
  data() {
    return {
      displayResults: false,
      filters: {},
      resultsList: [],
    }
  },
  watch: {
    filters: {
      handler(filters) {
        this.$store.dispatch('setComprehensiveReportFilters', filters);
        
        this.getReport();
      }
      , deep: true
    }
  },
  methods: {
    showFilters() {
      this.displayResults = false;

      this.$store.dispatch('resetComprehensiveReportResults');
    },
    setFilters(filters) {
      this.filters = filters;
    },
    updateSorting(selectedSorting) {
      this.filters.selectedSorting = selectedSorting;
    },
    updatePagination(pageIndex, pageSize) {
      this.filters.pageIndex = pageIndex;
      this.filters.pageSize = pageSize;
    },
    getReport() {
      if (!this.filters?.pageSize)
        return;
      
      let filtersVM = {
        ticketStatusEnums: this.filters.selectedTicketStatuses.map(x => x.key).toString(),
        ticketImportanceEnums: this.filters.selectedTicketImportances.map(x => x.key).toString(),
        companySectionIds: this.filters.selectedCompanySections.map(x => x.id).toString(),
        customerId: this.filters.customerId,
        ticketUserIds: this.filters.selectedUsers.map(x => x.id).toString(),
        referringUserId: this.filters.referringUser?.id,
        directlyReferredToUserId: this.filters.directlyReferredToUser?.id,
        ticketLabelIds: this.filters.selectedTicketLabels.map(x => x.id).toString(),
        searchString: this.filters.searchString,
        createDateFrom: this.filters.createDateFrom,
        createDateTo: this.filters.createDateTo,
        answeredDateFrom: this.filters.answeredDateFrom,
        answeredDateTo: this.filters.answeredDateTo,
        referDateFrom: this.filters.referDateFrom,
        referDateTo: this.filters.referDateTo,
        timeAwaitingCustomerAnswerFrom: this.filters.timeAwaitingCustomerAnswerFrom,
        timeAwaitingCustomerAnswerTo: this.filters.timeAwaitingCustomerAnswerTo,
        timeSpentFrom: this.filters.timeSpentFrom,
        timeSpentTo: this.filters.timeSpentTo,
        timeBeforeFirstChangeByCompanyFrom: this.filters.timeBeforeFirstChangeByCompanyFrom,
        timeBeforeFirstChangeByCompanyTo: this.filters.timeBeforeFirstChangeByCompanyTo,
        timeTakenToAnswerFrom: this.filters.timeTakenToAnswerFrom,
        timeTakenToAnswerTo: this.filters.timeTakenToAnswerTo,
        ticketOrderByEnum: this.filters.selectedSorting?.key ?? 1,
        pageIndex: this.filters.pageIndex,
        pageSize: this.filters.pageSize,
      };

      switch(this.filters?.selectedReportType?.key) {
        case 1:
          this.getTicketReport(filtersVM);
          break;
        
        case 5:
          this.getCompanyUserReport(filtersVM);
          break;

        case 9:
          this.getCustomerReport(filtersVM);
      }
    },
    getTicketReport(filtersVM) {
      ReportService.getComprehensiveTicketReportForCurrentCompany(filtersVM).then(response => {
        let result = response.data;
        
        if (result.success) {
          this.resultsList = result.data;
          this.displayResults = true;

          this.$store.dispatch('setComprehensiveReportResults', this.resultsList);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getCompanyUserReport(filtersVM) {
      ReportService.getComprehensiveCompanyUserReportForCurrentCompany(filtersVM).then(response => {
        let result = response.data;
        
        if (result.success) {
          this.resultsList = result.data;
          this.displayResults = true;

          this.$store.dispatch('setComprehensiveReportResults', this.resultsList);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getCustomerReport(filtersVM) {
      ReportService.getComprehensiveCustomerReportForCurrentCompany(filtersVM).then(response => {
        let result = response.data;
        
        if (result.success) {
          this.resultsList = result.data;
          this.displayResults = true;

          this.$store.dispatch('setComprehensiveReportResults', this.resultsList);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    }
  },
  beforeMount() {
    this.filters = this.$store.getters.getComprehensiveReportFilters;
    this.resultsList = this.$store.getters.getComprehensiveReportResults;

    this.displayResults = this.resultsList?.length > 0;
  }
}
</script>